"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TextInput = void 0;
const react_1 = __importStar(require("react"));
const prop_types_1 = require("prop-types");
const styled_components_1 = __importStar(require("styled-components"));
const Visibility_1 = __importDefault(require("@material-ui/icons/Visibility"));
const VisibilityOff_1 = __importDefault(require("@material-ui/icons/VisibilityOff"));
const onAutoFillStart = styled_components_1.keyframes ``;
const InputWrap = styled_components_1.default.label `
  display: block;
  position: relative;
  margin: 8px;
  padding: 8px 8px 0 8px;
`;
const FieldSet = styled_components_1.default.fieldset `
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  margin: 0;
  padding: 0 8px;
  border: 2px solid;
  border-radius: 8px;
  border-color: ${(props) => { var _a, _b; return (props === null || props === void 0 ? void 0 : props.isFocused) ? (_b = (_a = props === null || props === void 0 ? void 0 : props.theme) === null || _a === void 0 ? void 0 : _a.colours) === null || _b === void 0 ? void 0 : _b.purple : "#c8c3c3"; }};
  > legend {
    text-align: left;
    padding: 0 4px;
    visibility: hidden;
    font-size: 12px;
    width: auto;
    padding: 0;
    max-width: ${(props) => props.isFocused || props.hasValue ? "1000px" : "0px"};
    height: 1em;
    line-height: 1em;

    > span {
      display: inline-block;
      padding: 0 4px;
    }
  }
`;
const StyledInput = styled_components_1.default.input `
  padding: 12px 6px;
  display: block;
  width: 100%;
  background: none;
  border: 0;
  outline: 0;
  box-sizing: border-box;
  z-index: 1;
  position: relative;
  font-size: inherit;
  font-family: inherit;
  ${(props) => props["data-type"] === "password" && `padding-right:36px;`}
  &:-webkit-autofill, -webkit-autofill,
  -webkit-autofill:hover,
  -webkit-autofill:focus,
  -webkit-autofill:active {
    animation: ${onAutoFillStart}; // empty animation to detect autofill
    transition: background-color 50000s ease-in-out 0s;
    background-color: unset;
  }
`;
const Label = styled_components_1.default.span `
  position: absolute;
  left: ${(props) => (props.icon ? "48px" : "16px")};
  top: 18px;
  line-height: 1;
  transition: left 0.2s, top 0.2s, font-size 0.2s;
  z-index: 10;
  ${(props) => (props.isFocused || props.hasValue) &&
    `
    left: 14px;
    top: 0;
    font-size: 12px;
    color:#918787;
  `};
`;
const FieldIcon = styled_components_1.default.div `
  position: absolute;
  left: 16px;
  top: 14px;
  width: 24px;
  height: 24px;
  color: #c8c3c3;
  ${(props) => (props.isFocused || props.hasValue) &&
    `
 display:none;
  `}
  > svg {
    width: 100%;
    height: 100%;
  }
`;
const PasswordToggle = styled_components_1.default.div `
  z-index: 12;
  cursor: pointer;
  position: absolute;
  cursor: pointer;
  right: 16px;
  top: 12px;

  width: 24px;
  height: 24px;
  color: #c8c3c3;
`;
function TextInput(_a) {
    var { onChange, value, label, type, required, icon, name, onFocus, onAnimationStart, onBlur, className } = _a, rest = __rest(_a, ["onChange", "value", "label", "type", "required", "icon", "name", "onFocus", "onAnimationStart", "onBlur", "className"]);
    const [isFocused, setIsFocused] = react_1.useState(false);
    const [showPassword, setShowPassword] = react_1.useState(false);
    const handleBlur = (e) => {
        setIsFocused(false);
        setShowPassword(false);
        onBlur === null || onBlur === void 0 ? void 0 : onBlur(e);
    };
    const handleFocus = (e) => {
        setIsFocused(true);
        onFocus === null || onFocus === void 0 ? void 0 : onFocus(e);
    };
    const handleAutofill = (e) => {
        if (e.animationName === onAutoFillStart.name) {
            setIsFocused(true);
        }
    };
    const handleAnimationStart = (e) => {
        handleAutofill(e);
        onAnimationStart === null || onAnimationStart === void 0 ? void 0 : onAnimationStart(e);
    };
    const handlePasswordToggle = () => {
        setShowPassword((prev) => !prev);
    };
    const hasValue = typeof value !== "undefined" && value !== "";
    const requiredLabel = `${label}${required ? " *" : ""}`;
    return (react_1.default.createElement(InputWrap, { className: className },
        react_1.default.createElement(FieldSet, { isFocused: isFocused, hasValue: hasValue },
            react_1.default.createElement("legend", null,
                react_1.default.createElement("span", null, requiredLabel))),
        react_1.default.createElement(Label, { className: "label", icon: icon, isFocused: isFocused, hasValue: hasValue }, requiredLabel),
        icon && (react_1.default.createElement(FieldIcon, { className: "icon", isFocused: isFocused, hasValue: hasValue }, icon)),
        react_1.default.createElement(StyledInput, Object.assign({ name: name, type: showPassword ? "text" : type, "data-type": type, value: value, onChange: onChange, "data-testid": "text-input", onFocus: handleFocus, onBlur: handleBlur, onAnimationStart: handleAnimationStart }, rest)),
        type === "password" && (react_1.default.createElement(PasswordToggle, { onClick: handlePasswordToggle }, showPassword ? react_1.default.createElement(Visibility_1.default, null) : react_1.default.createElement(VisibilityOff_1.default, null)))));
}
exports.TextInput = TextInput;
TextInput.propTypes = {
    onChange: prop_types_1.func.isRequired,
    name: prop_types_1.string.isRequired,
    label: prop_types_1.string.isRequired,
    type: prop_types_1.string,
    value: prop_types_1.oneOfType([prop_types_1.string, prop_types_1.number]).isRequired,
    icon: prop_types_1.element,
};
TextInput.defaultProps = {
    type: "text",
};
//# sourceMappingURL=text.js.map